import { Box, styled, Tooltip } from '@mui/material';

export const ColorShowcase = ({ hex }: { hex: string }) => {
  const isHex = (v: string) => /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(v);
  const checkedBg = isHex(hex) ? hex : 'transparent';

  return (
    <Tooltip title={hex}>
      <StyledColorBox data-testid={`color-preview-${checkedBg}`} bgcolor={checkedBg} />
    </Tooltip>
  );
};

const StyledColorBox = styled(Box, { shouldForwardProp: (prop) => prop !== 'bgcolor' })<{
  bgcolor: string;
}>(({ theme, bgcolor }) => ({
  width: 25,
  height: 25,
  borderRadius: '50%',
  backgroundColor: bgcolor,
  border: `1px solid ${theme.palette.divider}`,
  flexShrink: 0,
}));
